/* eslint-disable */
import jwtEncode from 'jwt-encode';

import config from '../../../config/config';
import { PortalType } from '../../../config/enum';
import getFirstSubdomain from '../../../shared-functions/DomainsplitFunction';
import { getLocalStorageItem } from '../../../shared-functions/LocalStorage';
import getToken from '../../helpers';

/**
 * Build sync HS256 JWT string from a payload object
 * @param {Record<string, unknown>} payload payloadcls
 * @returns {string} JWT
 */
const signRoamingJwt = (payload: Record<string, unknown>) =>
  jwtEncode(payload, config.roamingJwtSecret);

/**
 * Get default headers details function
 * @returns {any} headers
 */
const defaultHeaders = () => {
  const activePortal = localStorage.getItem('activePortal');

  // Roaming (OCPI) module: Authorization carries tenantId + internalApiKey + role only
  // if (activePortal === PortalType.ROAMING) {
  //   const tenantId = getLocalStorageItem('tenantId');
  //   const internalApiKey = getLocalStorageItem('internalApiKey');
  //   const role = 'CPO';
  //   const roamingToken = signRoamingJwt({ tenantId, internalApiKey, role });
  //   return { Authorization: `Bearer ${roamingToken}` };
  // }

  const accessToken = getToken();
  const headers: HeadersInit = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const clientName = getLocalStorageItem('client-name');
  // const tenantDomain = clientName === 'energic' ? '' : clientName;

  const domain = getFirstSubdomain() || clientName;

  const blocked = ['admin-dev', 'admin-test', 'admin', 'localhost', 'cpo', 'cpo-test', 'cpo-dev'];

  if (domain && !blocked.some((d) => domain.includes(d))) {
    headers.domain = domain;
  } else {
    headers.domain = 'energic';
  }

  return Object.keys(headers).length > 0 ? headers : null;
};

export default defaultHeaders;
